

export const FETCH_AGENDAITEM_REQUEST = 'FETCH_AGENDAITEM_REQUEST';
export const FETCH_AGENDAITEM_REQUEST_COMPLETED = 'FETCH_AGENDAITEM_REQUEST_COMPLETED';
export const FETCH_AGENDAITEM_REQUEST_ERROR = 'FETCH_AGENDAITEM_REQUEST_ERROR';
export const FETCH_AGENDAITEM_RESET = 'FETCH_AGENDAITEM_RESET';

export const FETCH_AGENDAITEM_LIST_REQUEST = 'FETCH_AGENDAITEM_LIST_REQUEST';
export const FETCH_AGENDAITEM_LIST_REQUEST_COMPLETED = 'FETCH_AGENDAITEM_LIST_REQUEST_COMPLETED';
export const FETCH_AGENDAITEM_LIST_REQUEST_ERROR = 'FETCH_AGENDAITEM_LIST_REQUEST_ERROR';
export const FETCH_AGENDAITEM_LIST_RESET = 'FETCH_AGENDAITEM_LIST_RESET';

export const FETCH_AGENDAITEM_USER_LIST_REQUEST = 'FETCH_AGENDAITEM_USER_LIST_REQUEST';
export const FETCH_AGENDAITEM_USER_LIST_REQUEST_COMPLETED = 'FETCH_AGENDAITEM_USER_LIST_REQUEST_COMPLETED';
export const FETCH_AGENDAITEM_USER_LIST_REQUEST_ERROR = 'FETCH_AGENDAITEM_USER_LIST_REQUEST_ERROR';

export const ADD_AGENDAITEM_INITIAL = 'ADD_AGENDAITEM_INITIAL';
export const ADD_AGENDAITEM_REQUEST = 'ADD_AGENDAITEM_REQUEST';
export const ADD_AGENDAITEM_REQUEST_COMPLETED = 'ADD_AGENDAITEM_REQUEST_COMPLETED';
export const ADD_AGENDAITEM_REQUEST_ERROR = 'ADD_AGENDAITEM_REQUEST_ERROR';

export const UPDATE_FILE_REQUEST = 'UPDATE_FILE_REQUEST';
export const UPDATE_FILE_REQUEST_COMPLETED = 'UPDATE_FILE_REQUEST_COMPLETED';
export const UPDATE_FILE_REQUEST_ERROR = 'UPDATE_FILE_REQUEST_ERROR';


// WEBPACK FOOTER //
// ./constants/agendaitemdetails.js